import { DisplayBannerT } from "types/creative";
import CreativeComponent from 'components/atoms/CreativeComponent';
import { useAppState } from "context";

import "./BannerView.scss";

const BannerView = () => {
  const { displayBanner = {} as DisplayBannerT  } = useAppState();
  const { size: { width, height } = {} } = displayBanner;
 
  return (
    <div className={`banner-view-container size_${width}x${height}`}>
      <CreativeComponent videoControls={false} width={width} height={height}/>
    </div>
  );
};
export default BannerView;
